import { CompareBar } from './compareBar';
import { CompareButton } from './compareButton';
import { CompareModal } from './compareModal';
import { CompareProvider } from './compareProvider';
import { CompareToggle } from './compareToggle';

export type { CompareProduct } from './compareProvider';

export type { CompareProductsTrackingSummary } from './compareTracking';
export { compareProductsTrackingSummary } from './compareTracking';

export { MAX_COMPARE, useCompare, useCompareActions } from './compareProvider';

export const CompareProducts = Object.assign(CompareProvider, {
  Bar: CompareBar,
  Button: CompareButton,
  Modal: CompareModal,
  Toggle: CompareToggle,
});
